<div class="row">
  <div class="h5">
    Users
  </div>
  <dx-data-grid
    id="gridContainer"
    [dataSource]="dataSource"
    rowAlternationEnabled="true"
    [hoverStateEnabled]="true"
    keyExpr="id"
    [selectedRowKeys]="[]"
  >
    <dxo-editing
      mode="cell"
      [refreshMode]="'full'"
      [allowAdding]="canEdit()"
      [allowUpdating]="canEdit()"
      [allowDeleting]="canEdit()"
    >
    </dxo-editing>
    <dxo-selection mode="single"></dxo-selection>
    <dxo-export [enabled]="true" [fileName]="getExportFileName()"></dxo-export>

    <dxi-column dataField="id" [visible]="false"></dxi-column>
    <dxi-column dataField="first_name" caption="First Name">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="last_name" caption="Last Name">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="email" caption="Email">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule type="email"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="phone_number" caption="Phone"></dxi-column>
    <dxi-column *ngIf="canEdit()" [width]="'auto'" dataField="role">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxo-lookup
        [dataSource]="rolesData"
        valueExpr="name"
        displayExpr="name"
      ></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="created_at" dataType="date" caption="Created"></dxi-column>
    <dxi-column *ngIf="canEdit()" [width]="'auto'" cellTemplate="resetPassword"></dxi-column>

    <div *dxTemplate="let data of 'resetPassword'">
      <a class="link" (click)="resetPassword(data.data)">
        Reset Password
      </a>
    </div>
  </dx-data-grid>
</div>
